// extracted by mini-css-extract-plugin
export default {"token":"Token_token__fnUih","title":"Token_title__44OzV","list":"Token_list__kGzNF","item":"Token_item__gVmUW"};